// Charge la base commune
import './common.js'

// Financing Form
async function getFForm ($f) {
  $f.load()
  import(/* webpackChunkName: "financingForm" */ './js/components/financingForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du formulaire de financement
  const $c1 = $('form[name="fForm"]')
  if ($c1.length) {
    $c1.waypoint(function () {
      getFForm($c1)
      this.destroy()
    }, {
      offset: '100%'
    })
  }
})
